export const SEPARATION_DATE_LABELS = Object.freeze({
  terminate: 'Terminated Date',
  dnr: 'DNR Date',
  resign: 'Resigned Date',
  break_up: 'Contract End Date'
})

export const SEPARATION_ACTION_LABELS = Object.freeze({
  terminate: 'Terminated',
  resign: 'Resigned',
  dnr: 'DNR',
  break_up: 'End Contract'
})

export const SEPARATION_STATUS_LABELS = Object.freeze({
  terminate: 'Terminated',
  resign: 'Resigned',
  dnr: 'DNR',
  break_up: 'Contract Ended'
})

export const SEPARATION_TYPES = Object.freeze({
  terminate: Object.freeze({
    value: 'terminate',
    label: SEPARATION_ACTION_LABELS.terminate,
    description:
      "The facility ended this employee's employment. A termination letter is prepared as part of this process. Prepare the final paycheck within about 24 hours after the associate is separated. While Final Pay is active, the profile remains available; automatic disable happens after the process is completed."
  }),
  resign: Object.freeze({
    value: 'resign',
    label: SEPARATION_ACTION_LABELS.resign,
    description:
      'The employee chose to leave. A resignation letter is prepared and sent to them to sign; if they do not sign it, the facility completes it. Prepare the final paycheck within about 72 hours after the associate is separated. While Final Pay is active, the profile remains available; automatic disable happens after the process is completed.'
  }),
  dnr: Object.freeze({
    value: 'dnr',
    label: SEPARATION_ACTION_LABELS.dnr,
    description:
      'The facility ended the engagement and added this contractor to the DNR list. They cannot be scheduled for shifts here, and they are not to be brought back or reactivated later under any circumstances. No separation document is prepared.'
  }),
  break_up: Object.freeze({
    value: 'break_up',
    label: SEPARATION_ACTION_LABELS.break_up,
    description:
      'The contractor is no longer working with this facility — either they ended the contract themselves, or they have not worked here for a long time. They can no longer be scheduled for shifts.'
  })
})

export function getSeparationDateLabel(type) {
  return SEPARATION_DATE_LABELS[type] || 'Separated Date'
}

export function getSeparationStatusLabel(type) {
  return SEPARATION_STATUS_LABELS[type] || 'Separated'
}

export function getSeparationSubmissionDateLabel(type) {
  return type === 'break_up' ? 'Notice Date' : 'Submission Date'
}

export function getSeparationType(type) {
  return SEPARATION_TYPES[type]
}

export function isResignationSeparationType(type) {
  return type === 'resign' || type === 'break_up'
}
